// extracted by mini-css-extract-plugin
module.exports = {"page":"IpInfringement_page___B3YI","page--generic":"IpInfringement_page--generic__GVtht","blank-spacing":"IpInfringement_blank-spacing___Mhqj"};